import React from 'react';

export default {
  width: 10,
  height: 19,
  content: <path d="M0 .706787L9.46961 9.5 0 18.2932V.706787zM2 5.29321v8.41359L6.53039 9.5 2 5.29321z" />
};
